import { render, staticRenderFns } from "./TruncateHtml.vue?vue&type=template&id=03c87e83&scoped=true"
import script from "./TruncateHtml.vue?vue&type=script&lang=js"
export * from "./TruncateHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c87e83",
  null
  
)

export default component.exports